import React from 'react';
import { DollarSign, Hand, Flag, User, Target, List, ThumbsUp, Book, Award } from 'lucide-react';
import { MemberDTO } from '../../services/apiClient';
import { getMemberNoteIcons, getTagIconForTable } from '../../utils/noteIconUtils';

interface MemberNoteIconsProps {
    member: MemberDTO | undefined | null;
    tableContext: 'members' | 'activities' | 'courses' | 'endorsements' | 'rpl' | 'scores';
    recordId?: string;
}

const MemberNoteIcons: React.FC<MemberNoteIconsProps> = ({ member, tableContext, recordId }) => {
    const icons = getMemberNoteIcons(member, tableContext, recordId);

    if (icons.length === 0) {
        return null;
    }

    const getIconComponent = (type: string, color: string) => {
        const iconProps = {
            className: 'w-4 h-4',
            style: { color },
        };

        switch (type) {
            case 'payment':
                return <DollarSign {...iconProps} />;

            case 'disciplinary':
                return <Hand {...iconProps} />;

            case 'flag':
                return <Flag {...iconProps} />;

            case 'tag':
                const tagIconName = getTagIconForTable(tableContext);
                switch (tagIconName) {
                    case 'User':
                        return <User {...iconProps} />;
                    case 'Target':
                        return <Target {...iconProps} />;
                    case 'List':
                        return <List {...iconProps} />;
                    case 'ThumbsUp':
                        return <ThumbsUp {...iconProps} />;
                    case 'Book':
                        return <Book {...iconProps} />;
                    case 'Award':
                        return <Award {...iconProps} />;
                    default:
                        return null;
                }

            default:
                return null;
        }
    };

    return (
        <div className="flex items-center gap-1 mt-1">
            {icons.map((icon, index) => (
                <div key={`${icon.type}-${index}`} className="inline-flex">
                    {getIconComponent(icon.type, icon.color)}
                </div>
            ))}
        </div>
    );
};

export default MemberNoteIcons;
